module.exports = __webpack_public_path__ + "static/img/quancheng_02.1707b69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quancheng_02.png
// module id = hApC
// module chunks = 1